import PropTypes from 'prop-types';
import { CatContextualMenu } from '@blocks-react/components/ContextualMenu';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconMenuDots } from '@blocks-react/components/Icons/MenuDots';
import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';
import { BUTTON_VARIANTS } from '@app/constants/commonConstants';

const KebabMenu = ({ menuOptions = [], position, catListItemClassName }) => {
  return (
    <CatContextualMenu position={position}>
      <CatButton
        hideText
        slot="trigger"
        data-testid="kebabBtn"
        variant={BUTTON_VARIANTS.GHOST}
      >
        <CatIconMenuDots
          slot="after"
          color="information"
          iconTitle="kebabMenu"
        />
      </CatButton>
      <CatList>
        {menuOptions.map(
          ({ icon, label, className, showInMenu = true, onClick, id }) =>
            showInMenu && (
              <CatListItem
                key={id}
                onBlSelect={onClick}
                className={catListItemClassName}
                data-testid={label}
              >
                {icon ? (
                  <span className={`cat-u-display-flex ${className}`}>
                    {icon}
                    <span className="cat-u-padding-left-sm">{label}</span>
                  </span>
                ) : (
                  label
                )}
              </CatListItem>
            )
        )}
      </CatList>
    </CatContextualMenu>
  );
};

KebabMenu.propTypes = {
  menuOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      icon: PropTypes.node,
      label: PropTypes.string,
      className: PropTypes.string,
      onClick: PropTypes.func,
      showInMenu: PropTypes.bool
    })
  ),
  position: PropTypes.string,
  catListItemClassName: PropTypes.string
};

export default KebabMenu;
